import { getTimeDisplayFromDate } from '@/utils';

type StatusDetailsProps = {
  beginn?: Date;
  ende?: Date;
  mitarbeiter?: { vorname: string; nachname: string };
};

export function StatusDetails({
  beginn,
  ende,
  mitarbeiter,
}: StatusDetailsProps) {
  return (
    <div className="text-sm text-neutrals-700 font-normal">
      Für {beginn ? getTimeDisplayFromDate(beginn) : ''}
      <span className="px-[0.1rem]">-</span>
      {ende ? getTimeDisplayFromDate(ende) : ''} Uhr von{' '}
      {mitarbeiter?.vorname + ' '}
      {mitarbeiter?.nachname}
    </div>
  );
}
